import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { ApiResponse } from './auth.service';
import { TenantService } from './tenant.service';
import { HttpUrlEncodingCodec } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    tenantId: string | null = '';
    codec = new HttpUrlEncodingCodec();
    constructor(
        private readonly http: HttpService,
        private readonly tenantService: TenantService
    ) {
        this.tenantId = this.tenantService.getCurrentTenantId();
    }
    assignUserRole(payload: any): Observable<ApiResponse<any>> {
        return this.http.post<ApiResponse<any>>('user/invite-user-role', payload);
    }
    getQueryParam(param: string): string | null {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }
    verifyInviteUerRoleToken(key: string): Observable<any> {
        return this.http.get(`account/verify-invite-user-role-token?key=${this.codec.encodeValue(key)}`);
    }

    getUsersByTenant(): Observable<ApiResponse<any[]>> {
        return this.http.get<ApiResponse<any[]>>('User/get-user-by-teanant');
    }

    /**
     * Active users who hold the given role (e.g. "Manager"), for role-restricted picker dropdowns.
     * `employeeId` is only present when the user has a linked Employee record — Site Supervisor and
     * Project Supervisor pickers must submit this (not `id`), since Site.SiteSupervisorId and
     * ProjectConfig.SupervisorId are stored as Employee.Id, unlike every other role field which is
     * User.Id. A Supervisor-role user with no `employeeId` cannot be assigned to either field.
     */
    getUsersByRole(roleName: string): Observable<ApiResponse<{ id: string; fullName: string; employeeId?: string | null }[]>> {
        return this.http.get<ApiResponse<{ id: string; fullName: string; employeeId?: string | null }[]>>(`User/get-users-by-role/${encodeURIComponent(roleName)}`);
    }

    getUserById(id: string): Observable<ApiResponse<any>> {
        return this.http.get<ApiResponse<any>>(`user/get-user/${id}`);
    }

    createUser(user: any): Observable<ApiResponse<any>> {
        return this.http.post<ApiResponse<any>>('User/save-user', user);
    }

    updateUser(user: any): Observable<ApiResponse<any>> {
        return this.http.put<ApiResponse<any>>(`User/update-user`, user);
    }

    deleteUser(id: string): Observable<ApiResponse<void>> {
        return this.http.delete<ApiResponse<void>>(`user/delete-user/${id}`);
    }
}
